'use client';

import dynamic from 'next/dynamic';

export const HowItWorksModal = dynamic(
  () => import('./HowItWorksModal').then((mod) => mod.HowItWorksModal),
  { ssr: false }
);
